const loadScript = (src: string, options?: { async?: boolean; defer?: boolean; crossOrigin?: string }) => {
    if (typeof window === 'undefined') return; // Vi är inte i en webbläsarmiljö.

    if (document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = options?.async ?? true;
    script.defer = options?.defer ?? true;

    if (options?.crossOrigin && ['anonymous', 'use-credentials'].includes(options.crossOrigin)) {
        script.crossOrigin = options.crossOrigin;
    }

    // Lägg till skriptet till head utan att vänta på att det ska laddas
    document.head.appendChild(script);
};

const loadPolyfills = async () => {
    const promises = [];

    if (!Object.groupBy) promises.push(import('core-js/features/object/group-by'));
    if (!Object.hasOwn) promises.push(import('core-js/features/object/has-own'));
    if (!Array.prototype.at) promises.push(import('core-js/features/array/at'));

    await Promise.all(promises);
};

export default defineNuxtPlugin(async (nuxtApp) => {
    console.log('[Client-scripts]: Init.');
    try {
        await loadPolyfills();

        const host = window.location.hostname;
        const scripts = [
            { src: `https://consent.studio/${host === 'localhost' ? 'staging.zooingvar.com' : host}/banner.js` },
        ];

        scripts.map(({ src, ...options }) => loadScript(src, options));
    } catch (err) {
        console.error('[Script Loader] Failed to load scripts or polyfills:', err);
    }
});